import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Compromiso from './components/compromiso';
import Planes from './components/Planes';
import Beneficios from './components/Beneficios';
import Equipo from './components/Equipo';
import Testimonio from './components/Testimonio';
import Solicitar from './components/Solicitar';
import Footer from './components/Footer';
import BtnUp from './components/Acciones/BtnUp';
import WhatsAppChat from './components/WhatsAppChat';
import Soporte from './components/pages/Soporte';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <section id="inicio">
          <Home />
        </section>
        <section id="compromiso">
          <Compromiso />
        </section>
        <section id="planes">
          <Planes />
        </section>
        <section id="beneficios">
          <Beneficios />
        </section>
        <section id="equipo">
          <Equipo />
        </section>
        <section id="testimonios">
          <Testimonio />
        </section>
        <section id="cotizar">
          <Solicitar />
        </section>
        <section id="soporte">
          <Soporte />
        </section>
      </main>
      <Footer />
      <BtnUp />
      <WhatsAppChat />
    </div>
  );
}

export default App;
